import axios from 'axios'

const base = String(process.env.VUE_APP_API_BASE_URL || 'http://localhost:8091/')
  .trim()
  .replace(/\/?$/, '/')
const url = base + 'apiopen/'

export const httpOpen = axios.create({
  baseURL: url,
})

httpOpen.defaults.timeout = 8500

httpOpen.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default {
  url,
}
